// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3631) return "static/chunks/heroicons-ef8a48e9c8a9156a.js";
	if (chunkId === 1441) return "static/chunks/1441-f8bab2f4c670381d.js";
	if (chunkId === 1704) return "static/chunks/1704-d00f1ed0d13c3d5f.js";
	if (chunkId === 5483) return "static/chunks/5483-4fa706e65ec23aa8.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"635":"10907eb9d66fd124","762":"db89ce0d96236e67","2282":"5120636e86ecf488","2472":"dcb116484b653686","2905":"74b9e681989a9d5b","2953":"209d34151a3a66df","3415":"d535c4bf33e58fe1","3444":"e92f491fdab873cf"}[chunkId] + ".js";
};